<div class="d-flex gap-3 justify-content-center">
  <svg-icon src="assets/icons/visible.svg"
  class="cursor-pointer"
  matTooltip="Afficher détails"
  (click)="viewDialog($event)"></svg-icon>
    <svg-icon src="assets/icons/edit-action.svg"
      (click)="editDialog()" 
      class="cursor-pointer"
      matTooltip="Modifier"></svg-icon>
    <svg-icon src="assets/icons/trash-red.svg" 
    (click)="deletePerson()"
    class="cursor-pointer"
    matTooltip="Supprimer"
    ></svg-icon>
</div>
